export default "__VITE_ASSET__e9ace992__"